import React from 'react';
import PropTypes from 'prop-types';
import { Button, Modal, Icon, Chip, InputMulti } from '@weezevent/nacre';
import { useTranslation } from 'react-i18next';
import '../styles/emailsList.scss';

function isEmail(value) {
    return !value.match(/[\w-\.+]+@([\w-]+\.)+[\w-]{2,63}$/g) || value.split('@')[1] === 'free.fr' || value.split('@')[1] === 'laposte.net'; // eslint-disable-line
}

function EmailsListEdit({ open = false, value, setValue, onOpen, onClose }) {
    const [t] = useTranslation();
    const [emails, setEmails] = React.useState([]);

    const nbError = emails.filter(e => isEmail(e)).length;
    const errorMailUrl = !!emails.find(e => e.split('@')[1] === 'free.fr' || e.split('@')[1] === 'laposte.net');

    const _onClose = React.useCallback(() => {
        setEmails([]);
        onClose();
    }, [onClose]);

    const onSubmit = React.useCallback(() => {
        let tmpValue = [...value];
        tmpValue = tmpValue.concat(emails);
        tmpValue = Array.from(new Set(tmpValue));
        setValue(tmpValue);
        _onClose();
    }, [_onClose, emails, value]);

    return (
        <Modal
            className="email-list-modal"
            title={t('notifications.add-mail-modal.title')}
            subtitle={t('notifications.add-mail-modal.subtitle')}
            submitButton={<Button primary disabled={emails.length < 1 || Boolean(emails.find(e => isEmail(e)))} onClick={() => onSubmit()} label={t('ticket.common.action.add')} />}
            cancelButton={<Button onClick={() => _onClose()} label={t('ticket.common.action.cancel')} />}
            size="large"
            open={open}
            onOpen={onOpen}
            onClose={onClose}
        >
            <div>
                <InputMulti items={emails} onChange={value => setEmails(value)} placeholder={t('notifications.add-mail-modal.placeholder')} isValid={isEmail} />
                {nbError || errorMailUrl ? (
                    <div className="error-message-content">
                        <Icon name="info-circle" color="target" inverted />
                        <div className="error-message">
                            {errorMailUrl ? t('notifications.add-mail-modal.mail-error') : t('notifications.add-mail-modal.error', { count: nbError })}
                        </div>
                    </div>
                ) : (
                    undefined
                )}
                <div className="email-list-tips">
                    <Icon name="tips" />
                    <span>{t('notifications.tips_title')}</span>
                </div>
                <div className="email-list-tips-info">{t('notifications.add-mail-modal.tips_text')}</div>
            </div>
        </Modal>
    );
}

function EmailDisplay({ value, onDelete = null, organizerEmail }) {
    const { t } = useTranslation();
    return (
        <div className="wz-item__container">
            <div className="wz-email-item">{value}</div>
            <div className="wz-email-content">
                {value === organizerEmail && <Chip primary text={t('notifications.mail_organizer')} icon="user" />}
                <div className="we-email-item__icon" onClick={() => onDelete(value)}>
                    <Icon name="cross" />
                </div>
            </div>
        </div>
    );
}

function EmailsListDisplay({ value, setValue, organizerEmail }) {
    const onDelete = _value => setValue(value.filter(v => v !== _value));

    return (
        <div>
            {value.map((elt, i) => (
                <EmailDisplay key={i} organizerEmail={organizerEmail} onDelete={onDelete} value={elt} />
            ))}
        </div>
    );
}

export default function EmailsList({ setValue, value = [], organizerEmail }) {
    const { t } = useTranslation();
    const [modalOpen, setModalOpen] = React.useState(false);

    return (
        <div className="wz-emails-list">
            <div className="wz-emails-list__content">
                <EmailsListDisplay organizerEmail={organizerEmail} value={value} setValue={setValue} />
            </div>
            <div className="wz-emails-list__footer">
                <Button inverted primary key="primary" label={t('notifications.add_mail')} onClick={() => setModalOpen(true)} />
            </div>
            <EmailsListEdit setValue={setValue} value={value} open={modalOpen} onClose={() => setModalOpen(false)} />
        </div>
    );
}

EmailsList.prototype = {
    value: PropTypes.array,
    setValue: PropTypes.func,
    organizerEmail: PropTypes.string
};
